import Dashboard from "../layouts/Dashboard";
import { Home } from "./Home";
import Polizas from "./polizas/Polizas";
import SiniestroGEN from "./siniestros/SiniestroGEN";
import SiniestrosVAM from "./siniestros/SiniestrosVAM";
import { DocumentoAM } from "./zoho/DocumentoAM";
import { CredHospAmbulatorio } from "./zoho/CredHospAmbulatorio";
import { GestorUsuario } from "./GestorUsuario";
import React from "react";
import { Switch } from "react-router-dom";
import { RoutesPagesVam } from "../vam/RoutesPagesVam";
import { GestorEjecutivo } from "./GestorEjecutivo";
import { GestorSubAgente } from "./GestorSubAgente";
import { Siniestro } from "./zoho/Siniestro";
import { Beneficios } from "../beneficios/Beneficios";
import { EditBeneficio } from "../beneficios/EditBeneficio";
import { ListLogs } from "../logs/ListLogs";
import { has_role } from "../util/General";
import { useSelector } from "react-redux";
import { Tarjeta } from "../vam/pages/tarjeta/Tarjeta";
import { MailZerobounce } from "../vam/pages/emailZerobounce/MailZerobounce";
import { Banner } from "../coms/Banner";
import { NEWS } from "../pages/home/menu/menu-items.constants";

export const RoutesPagesGen = () => {
    const user = useSelector(state => state.user);
    const isAdmin = has_role(user, "ROLE_ADMIN");

    return (
        <Switch>
            <Dashboard exact path="/gen/home" component={Home} title={"Portal Asegurados GEN"} />
            <Dashboard exact path="/gen/polizas" component={Polizas} title={"Pólizas de Seguros"} />
            <Dashboard
                exact
                path="/gen/siniestros-gen"
                component={SiniestroGEN}
                title={"Consulta Siniestros Generales"}
            />
            <Dashboard exact path="/gen/siniestros-vam" component={SiniestrosVAM} title={"Consulta Siniestros VAM"} />
            <Dashboard
                exact
                path="/gen/docs-am/:id?"
                component={DocumentoAM}
                title={"Documentos Siniestros Asistencia Médica"}
            />
            <Dashboard
                exact
                path="/gen/docs-cred-hosp/:id?"
                component={CredHospAmbulatorio}
                title={"Documentos Credito Hospitalario/Ambulatorio"}
            />
            <Dashboard exact path="/gen/usuarios-gestor" component={GestorUsuario} title={"Creación de Usuarios"} />
            <Dashboard exact path="/gen/gestor-ejecutivo" component={GestorEjecutivo} title={"Creación de Usuarios"} />
            <Dashboard exact path="/gen/gestor-subagente" component={GestorSubAgente} title={"Creación de Usuarios"} />
            <Dashboard exact path="/gen/bannerGen" component={Banner} title={NEWS} />
            <Dashboard exact path="/gen/siniestro/ticket/:id" component={Siniestro} title={"Ticket"} />
            <Dashboard exact path="/gen/beneficios" component={Beneficios} title={"Beneficios"} />
            <Dashboard exact path="/gen/beneficio/:id" component={EditBeneficio} title={"Editar Beneficio"} />
            <Dashboard exact path="/gen/siniestro/ticket/:id" component={Siniestro} title={"Ticket"} />
            {isAdmin && <Dashboard exact path="/gen/logs" component={ListLogs} title={"Auditoría"} />}
            {isAdmin && (
                <Dashboard exact path="/gen/main-zerobounce" component={MailZerobounce} title={"Main Zerobounce"} />
            )}
            <Dashboard
                exact
                path="/gen/tarjeta"
                component={Tarjeta}
                title={"Mi tarjeta"}
                hideNavbar
                hideFooter
                classMainPanel={"w-100"}
            />
            <RoutesPagesVam />
        </Switch>
    );
};
